export default __webpack_public_path__ + "static/media/gallery13.a739d70e.jpg";